<template>
  <section>
    <div class="approvals-validation-table">
      <div class="approvals-validation-table__fund-container">
        <div class="approvals-validation-table__errors-container">
          <virtual-list
            class="fc-list-dynamic scroll-touch approvals-validation-table__errors-table"
            :item-class="'list-item-dynamic'"
            :data-key="'secId'"
            :data-sources="assortedFundApprovals"
            :data-component="ListItem"
            :estimate-size="45"
          />
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { get } from 'lodash';
import ListItem from '@/components/atoms/ListItem';

export default {
  name: 'approvals-validation-table',
  props: {
    type: {
      type: String,
      required: true,
    },
    approvals: {
      type: Array,
      required: true,
      validator: (funds) => Array.isArray(funds)
        && funds.every((fund) => fund.messages),
    },
  },
  data() {
    return {
      ListItem,
      errorTypes: {
        fundLevel: [
          'UnknownLineupIdentifier',
          'InvalidProgramTypeForProduct',
          'MissingLineupIdentifier',
          'InvalidatedFundByOtherFundInTheLineup',
        ],
      },
    };
  },
  methods: {
    getRowNumber(fund, fundIndex) {
      return get(fund, 'errorValues[0].rowNumber') || fundIndex + 2;
    },
    getRowMessageResume(fund, fundIndex, message) {
      const errorValues = get(fund, 'errorValues');
      const errors = get(fund, 'errors');
      let resume = message || '';
      if (Array.isArray(errors) && errors.includes('DuplicateWithConflictingData')) {
        // It has an error type property from backend to validate properly.
        resume = message;
      } else if (resume.toLowerCase().includes('duplicate') && resume.toLowerCase().includes('will process only one')) {
        // Sometimes it doesn't have an error type property from backend to validate properly.
        const rowNumber = get(errorValues, '[0].rowNumber');
        resume = `Row ${rowNumber} is a duplicate. We will only process one of the duplicates.`;
      } else {
        resume = get(errorValues, '[0].errorValue') || fundIndex + 2;
      }
      return resume;
    },
    // buildIndex(prefix, index) {
    //   return `${prefix}-${index}`;
    // },
    // errorLabel(type) {
    //   if (type === 'fund') {
    //     return 'Fund Errors';
    //   }
    //   if (type === 'approval') {
    //     return 'Approval Errors';
    //   }
    //   if (type === 'warning') {
    //     return '';
    //   }
    //   return '';
    // },
    // errorType(error) {
    //   if (includes(this.errorTypes.fundLevel, error)) {
    //     return 'fund';
    //   }
    //   return 'warning';
    // },
  },
  computed: {
    assortedFundApprovals() {
      const flatApprovals = [];
      this.approvals
        && this.approvals.forEach((fund, fundIndex) => {
          const formattedApproval = {
            fundName: fund.secId,
            secId: fund.secId || fundIndex,
            rowNumber: this.getRowNumber(fund, fundIndex),
            message: fund.messages[0],
            resume: fund.messages[0],
            errors: fund.errors,
          };
          flatApprovals.push(formattedApproval);
        });
      return Object.freeze(flatApprovals);
    },
    // tableType() {
    //   return `${this.type}-approvals-table`;
    // },
    // nameHeader() {
    //   if (this.type === 'invalid') {
    //     return 'Approval/Funds';
    //   }
    //   return 'Funds';
    // },
  },
};
</script>
<style lang="scss" scoped>
.approvals-validation-table {
  cursor: default;

  &__fund-container {
    margin: $mds-space-inset-1-x 0;
  }

  &__errors-table {
    width: 100%;
    tbody {
      tr {
        border-top: 1px solid $mds-color-neutral-80;
        &:hover {
          background: $mds-table-row-hover-color;
        }
        &:first-child {
          border: none;
        }
        td {
          padding: $mds-space-inset-2-x $mds-space-inset-1-x;
          &:first-child {
            padding-left: 0;
          }
        }
      }
    }
    thead {
      td {
        font-weight: $mds-font-weight-bold;
      }
    }
  }
}

.fc-list-dynamic {
  @include vertical-scroll-gradient();
  width: 100%;
  height: 400px;
  max-height: 400px;
  overflow-y: auto;
  .list-item-dynamic {
    display: flex;
    align-items: center;
    padding: 1em;
    border-bottom: $mds-border-separator-on-light;
    border-color: lightgray;
  }
}
</style>
